  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.section-video');

    sections.forEach(section => {
      const button = section.querySelector('.toggle-sound-button');
      if (!button) return;

      const getVisibleVideo = () => {
        const desktopVideo = section.querySelector('.desktop-video');
        const mobileVideo = section.querySelector('.mobile-video');
        const isMobile = window.innerWidth <= 767;

        return isMobile && mobileVideo ? mobileVideo : desktopVideo;
      };

      // Set initial button label
      const initialVideo = getVisibleVideo();
      if (initialVideo) {
        button.textContent = initialVideo.muted ? 'Unmute' : 'Mute';
      }

      button.addEventListener('click', function () {
        const currentVideo = getVisibleVideo();

        // Mute all videos on the page except current
        document.querySelectorAll('.desktop-video, .mobile-video').forEach(video => {
          if (video !== currentVideo) {
            video.muted = true;
          }
        });

        // Update all buttons
        document.querySelectorAll('.toggle-sound-button').forEach(btn => {
          btn.textContent = 'Unmute';
        });

        // Toggle mute on current video
        if (currentVideo) {
          currentVideo.muted = !currentVideo.muted;
          button.textContent = currentVideo.muted ? 'Unmute' : 'Mute';

          // Ensure it's playing
          if (currentVideo.paused) {
            currentVideo.play().catch(e => console.warn('Autoplay issue:', e));
          }
        }
      });
    });
  });